import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AddEditPartnerContract } from '../components/features/partners/add-edit-partner-contract/add-edit-partner-contract';

export const canDeactivatePartnerContactGuard: CanDeactivateFn<AddEditPartnerContract> = (component) => {
  const confirmationService = inject(ConfirmationService);
  const translateService = inject(TranslateService);

  // Check if form has unsaved changes
  const hasUnsavedChanges = component.partnerContactForm.dirty && !component.isContactSaved;

  if (!hasUnsavedChanges) {
    return true;
  }

  return new Promise<boolean>((resolve) => {
    confirmationService.confirm({
      message: translateService.instant('contact.guard.message'),
      header: translateService.instant('contact.guard.header'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: translateService.instant('contact.guard.accept'),
      rejectLabel: translateService.instant('contact.guard.reject'),
      accept: () => {
        resolve(true);
      },
      reject: () => {
        resolve(false);
      }
    });
  });
};
